// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основной контейнер */
.st-attendance-section {
  width: 1000px;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0;
  margin-bottom: 0;
  position: relative;
  transition: width 0.3s ease;
}

/* Заголовок */
.st-attendance-header {
  margin-bottom: 24px;
  padding: 0 8px;
  width: 100%;
}

.st-attendance-title-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.st-attendance-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
}

.st-group-title {
  font-size: 24px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

/* Стили для заголовка с кнопками информации и обновления */
.st-attendance-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
}

.st-header-left-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.st-header-right-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.st-back-button {
  background: white;
  color: #002FA7;
  border: none;
  font-size: 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 4px;
}

.st-back-button img {
  width: 34px;
  height: 34px;
  transition: transform 0.3s ease;
}

.st-back-button:hover {
  transform: translateY(-1px);
}

/* Стили для кнопок в заголовке */
.st-header-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.st-header-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.st-header-btn:active {
  transform: translateY(0);
}

/* Стили для кнопки обновления */
.st-refresh-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.st-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.st-refresh-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
  filter: brightness(0.8);
}

.st-refresh-spin {
  animation: st-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  filter: brightness(1);
}

@keyframes st-spin {
  0% { 
    transform: rotate(0deg);
    filter: brightness(0.8);
  }
  50% {
    filter: brightness(1.2);
  }
  100% { 
    transform: rotate(360deg);
    filter: brightness(0.8);
  }
}

/* Базовые стили для всех тултипов */
.st-info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.st-info-icon-text {
  font-weight: bold;
  margin-right: 4px;
}

.st-info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(8px);
  background: white;
  border: 1px solid #e0e7ff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  overflow: hidden;
}

/* Размеры тултипов */
.st-info-tooltip.small {
  width: 320px;
  max-width: calc(80vw - 40px);
}

.st-info-tooltip.large {
  width: 320px;
  max-width: calc(100vw - 40px);
}

/* Стили контента */
.st-info-tooltip-content {
  color: #374151;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  word-break: break-word;
  white-space: normal;
  overflow-y: auto;
  max-height: 50vh;
  padding: 0;
}

.st-info-header {
  padding: 18px 20px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
  border-bottom: 1px solid #e0e7ff;
}

.st-info-title h3 {
  margin: 0 0 6px 0;
  color: #002FA7;
  font-size: 16px;
  font-weight: 700;
}

.st-info-title p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.st-info-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.st-info-section:last-child {
  border-bottom: none;
}

.st-info-section h4 {
  margin: 0 0 12px 0;
  color: #002FA7;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.st-info-section h4::before {
  content: '';
  width: 3px;
  height: 14px;
  background: #002FA7;
  border-radius: 2px;
}

.st-features-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.st-feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 400;
}

.st-feature-icon {
  width: 6px;
  height: 6px;
  background: #002FA7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.st-statuses-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.st-status-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.st-status-demo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.st-status-info span {
  color: #576374;
  font-size: 12px;
}

.st-status-present { background: #2cbb00; }
.st-status-absent { background: #f59e0b; }
.st-status-not { background: #ef4444; }
.st-status-empty {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #94a3b8;
  text-shadow: none;
}

.st-usage-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.st-step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

.st-step-number {
  width: 20px;
  height: 20px;
  background: #002FA7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.st-step span:last-child {
  color: #374151;
  font-size: 12px;
  line-height: 1.4;
}

.st-step code {
  background: #f1f5f9;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  color: #002FA7;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

.st-info-tip {
  padding: 12px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
  border-top: 1px solid #e0e7ff;
  color: #374151;
  font-size: 12px;
  line-height: 1.4;
}

/* Анимации */
@keyframes st-tooltipAppear {
  0% {
    opacity: 0;
    transform: translateX(0%) translateY(5px);
  }
  100% {
    opacity: 1;
    transform: translateX(0%) translateY(8px);
  }
}

.st-info-icon-btn:hover .st-info-tooltip,
.st-info-icon-btn:focus-within .st-info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
  animation: st-tooltipAppear 0.3s ease;
}

.st-info-tooltip::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 16px;
  transform: rotate(45deg);
  width: 10px;
  height: 10px;
  background: white;
  border-left: 1px solid #e0e7ff;
  border-top: 1px solid #e0e7ff;
  z-index: 1;
}

/* Предупреждение о кэше */
.st-cache-warning {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 12px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.st-cache-warning button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #856404;
}

/* Стили для выбора предмета */
.st-subject-selector-container {
  margin-bottom: 20px;
  padding: 0 8px;
}

.st-subject-selector {
  display: flex;
  align-items: center;
  gap: 16px;
}

.st-subject-label {
  font-weight: 500;
  color: #002FA7;
}

.st-subject-select {
  padding: 10px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  min-width: 300px;
  background-color: white;
  cursor: pointer;
}

.st-subject-select:focus {
  outline: none;
  border-color: #002FA7;
}

.st-subject-select:disabled {
  background-color: #f8fafc;
  cursor: not-allowed;
  opacity: 0.7;
}

.st-subject-info {
  margin-bottom: 16px;
  padding: 0 8px;
}

.st-teacher-info {
  font-size: 14px;
  color: #64748b;
}

.st-teacher-name {
  font-weight: 500;
  color: #1e293b;
}

/* Фильтры */
.st-attendance-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 8px;
  margin-bottom: 20px;
}

.st-date-range-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.st-date-range-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.st-date-range-label {
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  white-space: nowrap;
}

.st-date-range-input {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  min-width: 80px;
  transition: all 0.2s ease;
  height: 35px;
}

.st-date-range-input:focus {
  outline: none;
  border-color: #002FA7;
}

/* Контейнер таблицы */
.st-attendance-table-container {
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.st-attendance-table-wrapper {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.st-attendance-table {
  min-width: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.st-attendance-table th {
  background: white;
  color: #002c9c;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 8px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 30;
}

/* Фиксированные заголовки */
.st-attendance-table th.st-column-number {
  position: sticky;
  left: 0;
  z-index: 50;
  background: #f8fafc;
  border-right: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.st-attendance-table th.st-column-name {
  position: sticky;
  left: 60px;
  z-index: 50;
  background: #f8fafc;
  border-right: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.st-attendance-table th.st-column-percentage {
  position: sticky;
  right: 0;
  z-index: 50;
  background: #f8fafc;
  border-left: 2px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
}

.st-attendance-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  height: 50px;
  position: relative;
  z-index: 1;
}

/* Фиксированные ячейки */
.st-attendance-table td.st-column-number {
  position: sticky;
  left: 0;
  z-index: 40;
  background: white;
  border-right: 2px solid #e2e8f0;
}

.st-attendance-table td.st-column-name {
  position: sticky;
  left: 60px;
  z-index: 40;
  background: white;
  border-right: 2px solid #e2e8f0;
  text-align: left !important;
}

.st-attendance-table td.st-column-percentage {
  position: sticky;
  right: 0;
  z-index: 40;
  background: white;
  border-left: 2px solid #e2e8f0;
}

/* Подсветка при наведении на строку */
.st-attendance-table tbody tr:hover td.st-column-number,
.st-attendance-table tbody tr:hover td.st-column-name,
.st-attendance-table tbody tr:hover td.st-column-percentage {
  background: #f0f4ff;
}

/* Конкретные размеры и позиции колонок */
.st-column-number {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.st-column-name {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  text-align: left;
}

.st-column-date {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.st-column-percentage {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

/* Стили для ячеек */
.st-cell-number {
  font-weight: 600;
  color: #002FA7;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.st-cell-name {
  text-align: left !important;
  padding: 12px 16px !important;
  font-weight: 500;
  color: #1e293b;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Стили для статусов посещаемости */
.st-cell-status-container {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  text-align: center;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100%;
}

.st-cell-status {
  height: 36px;
  width: 36px;
  border-radius: 8px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.st-cell-status-container:hover .st-cell-status {
  transform: scale(1.15);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.st-cell-status-container.st-editing {
  border: 2px solid #002FA7;
  border-radius: 6px;
  background: white;
}

/* Цвета для статусов */
.st-status-present {
  background: #2cbb00;
}

.st-status-absent {
  background: #f59e0b;
}

.st-status-not {
  background: #ef4444;
}

.st-status-empty {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #cbd5e1;
  text-shadow: none;
}

.st-status-empty:hover {
  border-color: #002FA7;
  color: #002FA7;
  background: #f0f4ff;
}

/* Стили для процента посещаемости студентов */
.st-cell-percentage {
  font-weight: 600;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 20px;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

/* Inputs */
.st-status-input-container {
  width: 100%;
  height: 100%;
}

.st-status-input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
  outline: none;
}

.st-status-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

/* Контент даты */
.st-dates-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 34px;
  width: 100%;
}

.st-dates-title {
  font-weight: 600;
  color: #002c9c;
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
}

.st-lesson-id {
  font-size: 1px;
  font-weight: 100;
  color: transparent;
}

.st-date-header-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
}

.st-date-info-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #64748b;
  padding: 0 4px;
}

.st-date-info-btn:hover {
  color: #002FA7;
}

/* Общая посещаемость группы */
.st-group-attendance-footer {
  padding: 16px 14px;
  background: transparent;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.st-group-attendance-percentage {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: white;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.st-percentage-circle {
  width: 62px;
  height: 62px;  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: conic-gradient(
    var(--percentage-color, #002FA7) 0% var(--percentage, 0%),
    #f1f5f9 var(--percentage, 0%) 100%
  );
}

.st-percentage-circle::before {
  content: '';
  position: absolute;
  width: 52px;
  height: 52px;
  background: white;
  border-radius: 50%;
}

.st-percentage-value {
  font-size: 15px; 
  font-weight: 800;
  z-index: 1;
  color: var(--percentage-color, #002FA7);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.st-percentage-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  padding-right: 5px;
}

/* Модальные окна */
.st-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.st-modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  min-width: 400px;
  max-width: 500px;
}

.st-modal-content h3 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 18px;
}

.st-reason-textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  margin-bottom: 16px;
}

.st-reason-textarea:focus {
  outline: none;
  border-color: #002FA7;
}

.st-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.st-gradient-btn {
  background: linear-gradient(135deg, #011080 0%, #0f53ff 100%);
  border: 2px solid rgba(66, 92, 177, 0.508);
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  min-width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.st-gradient-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);
}

.st-cancel-btn {
  padding: 8px 16px;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}

.st-cancel-btn:hover {
  border-color: #64748b;
  background: #f8fafc;
}

/* Стили для модального окна информации о занятии */
.st-lesson-info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.st-lesson-info-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 95%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.st-lesson-info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  border-radius: 12px 12px 0 0;
}

.st-lesson-info-modal-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
}

.st-lesson-info-modal-close {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  color: #64748b;
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.st-lesson-info-modal-close:hover {
  background: #e2e8f0;
  color: #374151;
}

.st-lesson-info-modal-content {
  padding: 24px;
  background: white;
}

/* Детальная информация о занятии */
.st-lesson-details-info {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.st-info-section-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.st-info-section-content {
  padding: 14px;
}

/* ОДИНАКОВАЯ СЕТКА для деталей и статистики - 4 колонки */
.st-info-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.st-info-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  text-align: center;
  min-height: 80px;
  justify-content: center;
}

.st-info-grid-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 1.2;
}

.st-info-grid-value {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

/* Статистика посещаемости */
.st-attendance-stats-section {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}

.st-attendance-stats-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.st-attendance-stats-content {
  padding: 20px;
}

/* Процент посещаемости - отдельный блок */
.st-attendance-percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e6f0ff 100%);
  border-radius: 8px;
  border: 1px solid #c7d2fe;
  margin-top: 16px;
}

/* Стили для состояния загрузки */
.st-lesson-info-loading {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
}

.st-lesson-info-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f1f5f9;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: st-spin 1s linear infinite;
  margin: 0 auto 16px;
}

.st-lesson-info-loading-text {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
}

/* Стили для отсутствующей информации */
.st-lesson-info-no-data {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  margin: 20px 0;
}

.st-lesson-info-no-data-icon {
  font-size: 48px;
  margin-bottom: 16px;
  color: #cbd5e1;
}

.st-lesson-info-no-data h4 {
  margin: 0 0 12px 0;
  color: #475569;
  font-size: 18px;
  font-weight: 600;
}

.st-lesson-info-no-data p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

/* Стили для состояния загрузки данных */
.st-loading-message {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
  background: white;
  border-radius: 12px;
  margin: 20px 0;
  border: 1px solid #e2e8f0;
}

.st-no-data-message {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
  background: white;
  border-radius: 12px;
  margin: 20px 0;
  border: 1px solid #e2e8f0;
}

/* Стили для скроллбара */
.st-attendance-table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.st-attendance-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.st-attendance-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.st-attendance-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Адаптивность */
@media (max-width: 768px) {
  .st-attendance-section {
    width: 100%;
    min-width: 100%;
    padding: 12px;
  }
  
  .st-attendance-filters {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .st-attendance-title-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .st-modal-content {
    min-width: 90vw;
    margin: 20px;
  }
  
  .st-column-name {
    width: 200px;
    min-width: 200px;
  }
  
  .st-column-number {
    width: 50px;
    min-width: 50px;
  }
  
  .st-percentage-circle {
    width: 80px;
    height: 80px;
  }
  
  .st-percentage-circle::before {
    width: 64px;
    height: 64px;
  }
  
  .st-percentage-value {
    font-size: 16px;
  }
  
  .st-cell-status {
    height: 32px;
    width: 32px;
    font-size: 12px;
  }
  
  .st-subject-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .st-subject-select {
    min-width: 100%;
  }
}

@media (max-width: 768px) {
  .st-attendance-cabinet-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .st-header-btn {
    justify-content: center;
    width: 100%;
  }
  
  .st-info-tooltip {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    min-width: 280px;
    max-width: 90vw;
  }
  
  .st-info-icon-btn:hover .st-info-tooltip {
    opacity: 0;
    visibility: hidden;
  }
  
  .st-info-icon-btn:focus .st-info-tooltip,
  .st-info-icon-btn:active .st-info-tooltip {
    opacity: 1;
    visibility: visible;
  }
}

@media (max-width: 480px) {
  .st-header-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .st-lesson-info-modal-header {
    padding: 16px;
  }
  
  .st-lesson-info-modal-content {
    padding: 16px;
  }
  
  .st-info-grid-4 {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .st-info-grid-item {
    padding: 14px 8px;
    min-height: 65px;
  }
  
  .st-info-grid-value {
    font-size: 16px;
  }
  
  .st-percentage-circle {
    width: 50px;
    height: 50px;
  }
  
  .st-percentage-circle::before {
    width: 40px;
    height: 40px;
  }
  
  .st-percentage-value {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/st-components/HeadStudentAttendanceSectionStyle.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,iBAAiB;EACjB,4DAA4D;EAC5D,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,2CAA2C;EAC3C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB,mBAAmB,EAAE;AAC1C,oBAAoB,mBAAmB,EAAE;AACzC,iBAAiB,mBAAmB,EAAE;AACtC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;;;EAGE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Основной контейнер */\n.st-attendance-section {\n  width: 1000px;\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  padding: 0;\n  margin-bottom: 0;\n  position: relative;\n  transition: width 0.3s ease;\n}\n\n/* Заголовок */\n.st-attendance-header {\n  margin-bottom: 24px;\n  padding: 0 8px;\n  width: 100%;\n}\n\n.st-attendance-title-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.st-attendance-title {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.st-group-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n/* Стили для заголовка с кнопками информации и обновления */\n.st-attendance-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.st-header-left-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.st-header-right-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.st-back-button {\n  background: white;\n  color: #002FA7;\n  border: none;\n  font-size: 10px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  margin-left: 4px;\n}\n\n.st-back-button img {\n  width: 34px;\n  height: 34px;\n  transition: transform 0.3s ease;\n}\n\n.st-back-button:hover {\n  transform: translateY(-1px);\n}\n\n/* Стили для кнопок в заголовке */\n.st-header-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n.st-header-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.st-header-btn:active {\n  transform: translateY(0);\n}\n\n/* Стили для кнопки обновления */\n.st-refresh-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n.st-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.st-refresh-icon {\n  width: 24px;\n  height: 24px;\n  transition: transform 0.3s ease;\n  filter: brightness(0.8);\n}\n\n.st-refresh-spin {\n  animation: st-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  filter: brightness(1);\n}\n\n@keyframes st-spin {\n  0% { \n    transform: rotate(0deg);\n    filter: brightness(0.8);\n  }\n  50% {\n    filter: brightness(1.2);\n  }\n  100% { \n    transform: rotate(360deg);\n    filter: brightness(0.8);\n  }\n}\n\n/* Базовые стили для всех тултипов */\n.st-info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.st-info-icon-text {\n  font-weight: bold;\n  margin-right: 4px;\n}\n\n.st-info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(8px);\n  background: white;\n  border: 1px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 0;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Размеры тултипов */\n.st-info-tooltip.small {\n  width: 320px;\n  max-width: calc(80vw - 40px);\n}\n\n.st-info-tooltip.large {\n  width: 320px;\n  max-width: calc(100vw - 40px);\n}\n\n/* Стили контента */\n.st-info-tooltip-content {\n  color: #374151;\n  font-size: 13px;\n  line-height: 1.4;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n  overflow-y: auto;\n  max-height: 50vh;\n  padding: 0;\n}\n\n.st-info-header {\n  padding: 18px 20px 14px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);\n  border-bottom: 1px solid #e0e7ff;\n}\n\n.st-info-title h3 {\n  margin: 0 0 6px 0;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.st-info-title p {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.st-info-section {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.st-info-section:last-child {\n  border-bottom: none;\n}\n\n.st-info-section h4 {\n  margin: 0 0 12px 0;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.st-info-section h4::before {\n  content: '';\n  width: 3px;\n  height: 14px;\n  background: #002FA7;\n  border-radius: 2px;\n}\n\n.st-features-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.st-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.st-feature-icon {\n  width: 6px;\n  height: 6px;\n  background: #002FA7;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.st-statuses-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.st-status-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.st-status-demo {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n\n.st-status-info span {\n  color: #576374;\n  font-size: 12px;\n}\n\n.st-status-present { background: #2cbb00; }\n.st-status-absent { background: #f59e0b; }\n.st-status-not { background: #ef4444; }\n.st-status-empty {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #94a3b8;\n  text-shadow: none;\n}\n\n.st-usage-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.st-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n}\n\n.st-step-number {\n  width: 20px;\n  height: 20px;\n  background: #002FA7;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.st-step span:last-child {\n  color: #374151;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.st-step code {\n  background: #f1f5f9;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 11px;\n  color: #002FA7;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n}\n\n.st-info-tip {\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);\n  border-top: 1px solid #e0e7ff;\n  color: #374151;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n/* Анимации */\n@keyframes st-tooltipAppear {\n  0% {\n    opacity: 0;\n    transform: translateX(0%) translateY(5px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%) translateY(8px);\n  }\n}\n\n.st-info-icon-btn:hover .st-info-tooltip,\n.st-info-icon-btn:focus-within .st-info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n  animation: st-tooltipAppear 0.3s ease;\n}\n\n.st-info-tooltip::before {\n  content: '';\n  position: absolute;\n  top: -5px;\n  left: 16px;\n  transform: rotate(45deg);\n  width: 10px;\n  height: 10px;\n  background: white;\n  border-left: 1px solid #e0e7ff;\n  border-top: 1px solid #e0e7ff;\n  z-index: 1;\n}\n\n/* Предупреждение о кэше */\n.st-cache-warning {\n  background: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n  padding: 12px 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.st-cache-warning button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #856404;\n}\n\n/* Стили для выбора предмета */\n.st-subject-selector-container {\n  margin-bottom: 20px;\n  padding: 0 8px;\n}\n\n.st-subject-selector {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.st-subject-label {\n  font-weight: 500;\n  color: #002FA7;\n}\n\n.st-subject-select {\n  padding: 10px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  min-width: 300px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.st-subject-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.st-subject-select:disabled {\n  background-color: #f8fafc;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.st-subject-info {\n  margin-bottom: 16px;\n  padding: 0 8px;\n}\n\n.st-teacher-info {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.st-teacher-name {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n/* Фильтры */\n.st-attendance-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 8px;\n  margin-bottom: 20px;\n}\n\n.st-date-range-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.st-date-range-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.st-date-range-label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.st-date-range-input {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  min-width: 80px;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.st-date-range-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Контейнер таблицы */\n.st-attendance-table-container {\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.st-attendance-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  position: relative;\n}\n\n.st-attendance-table {\n  min-width: 100%;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n.st-attendance-table th {\n  background: white;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 16px 8px;\n  text-align: center;\n  border-bottom: 1px solid #e2e8f0;\n  user-select: none;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 30;\n}\n\n/* Фиксированные заголовки */\n.st-attendance-table th.st-column-number {\n  position: sticky;\n  left: 0;\n  z-index: 50;\n  background: #f8fafc;\n  border-right: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.st-attendance-table th.st-column-name {\n  position: sticky;\n  left: 60px;\n  z-index: 50;\n  background: #f8fafc;\n  border-right: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.st-attendance-table th.st-column-percentage {\n  position: sticky;\n  right: 0;\n  z-index: 50;\n  background: #f8fafc;\n  border-left: 2px solid #e2e8f0;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.st-attendance-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-align: center;\n  height: 50px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Фиксированные ячейки */\n.st-attendance-table td.st-column-number {\n  position: sticky;\n  left: 0;\n  z-index: 40;\n  background: white;\n  border-right: 2px solid #e2e8f0;\n}\n\n.st-attendance-table td.st-column-name {\n  position: sticky;\n  left: 60px;\n  z-index: 40;\n  background: white;\n  border-right: 2px solid #e2e8f0;\n  text-align: left !important;\n}\n\n.st-attendance-table td.st-column-percentage {\n  position: sticky;\n  right: 0;\n  z-index: 40;\n  background: white;\n  border-left: 2px solid #e2e8f0;\n}\n\n/* Подсветка при наведении на строку */\n.st-attendance-table tbody tr:hover td.st-column-number,\n.st-attendance-table tbody tr:hover td.st-column-name,\n.st-attendance-table tbody tr:hover td.st-column-percentage {\n  background: #f0f4ff;\n}\n\n/* Конкретные размеры и позиции колонок */\n.st-column-number {\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.st-column-name {\n  width: 250px;\n  min-width: 250px;\n  max-width: 250px;\n  text-align: left;\n}\n\n.st-column-date {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.st-column-percentage {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n/* Стили для ячеек */\n.st-cell-number {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 14px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.st-cell-name {\n  text-align: left !important;\n  padding: 12px 16px !important;\n  font-weight: 500;\n  color: #1e293b;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Стили для статусов посещаемости */\n.st-cell-status-container {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  text-align: center;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 50px;\n  width: 100%;\n}\n\n.st-cell-status {\n  height: 36px;\n  width: 36px;\n  border-radius: 8px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.st-cell-status-container:hover .st-cell-status {\n  transform: scale(1.15);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n.st-cell-status-container.st-editing {\n  border: 2px solid #002FA7;\n  border-radius: 6px;\n  background: white;\n}\n\n/* Цвета для статусов */\n.st-status-present {\n  background: #2cbb00;\n}\n\n.st-status-absent {\n  background: #f59e0b;\n}\n\n.st-status-not {\n  background: #ef4444;\n}\n\n.st-status-empty {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #cbd5e1;\n  text-shadow: none;\n}\n\n.st-status-empty:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n  background: #f0f4ff;\n}\n\n/* Стили для процента посещаемости студентов */\n.st-cell-percentage {\n  font-weight: 600;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  display: inline-block;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Inputs */\n.st-status-input-container {\n  width: 100%;\n  height: 100%;\n}\n\n.st-status-input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-weight: 600;\n  font-size: 13px;\n  color: #1e293b;\n  outline: none;\n}\n\n.st-status-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* Контент даты */\n.st-dates-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-top: 34px;\n  width: 100%;\n}\n\n.st-dates-title {\n  font-weight: 600;\n  color: #002c9c;\n  font-size: 14px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.st-lesson-id {\n  font-size: 1px;\n  font-weight: 100;\n  color: transparent;\n}\n\n.st-date-header-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 4px;\n}\n\n.st-date-info-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #64748b;\n  padding: 0 4px;\n}\n\n.st-date-info-btn:hover {\n  color: #002FA7;\n}\n\n/* Общая посещаемость группы */\n.st-group-attendance-footer {\n  padding: 16px 14px;\n  background: transparent;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.st-group-attendance-percentage {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 50px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.st-percentage-circle {\n  width: 62px;\n  height: 62px;  \n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: conic-gradient(\n    var(--percentage-color, #002FA7) 0% var(--percentage, 0%),\n    #f1f5f9 var(--percentage, 0%) 100%\n  );\n}\n\n.st-percentage-circle::before {\n  content: '';\n  position: absolute;\n  width: 52px;\n  height: 52px;\n  background: white;\n  border-radius: 50%;\n}\n\n.st-percentage-value {\n  font-size: 15px; \n  font-weight: 800;\n  z-index: 1;\n  color: var(--percentage-color, #002FA7);\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.st-percentage-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  padding-right: 5px;\n}\n\n/* Модальные окна */\n.st-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.st-modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  min-width: 400px;\n  max-width: 500px;\n}\n\n.st-modal-content h3 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 18px;\n}\n\n.st-reason-textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.st-reason-textarea:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.st-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.st-gradient-btn {\n  background: linear-gradient(135deg, #011080 0%, #0f53ff 100%);\n  border: 2px solid rgba(66, 92, 177, 0.508);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.st-gradient-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);\n}\n\n.st-cancel-btn {\n  padding: 8px 16px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.st-cancel-btn:hover {\n  border-color: #64748b;\n  background: #f8fafc;\n}\n\n/* Стили для модального окна информации о занятии */\n.st-lesson-info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.st-lesson-info-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 95%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.st-lesson-info-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.st-lesson-info-modal-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.st-lesson-info-modal-close {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 20px;\n  cursor: pointer;\n  color: #64748b;\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.st-lesson-info-modal-close:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.st-lesson-info-modal-content {\n  padding: 24px;\n  background: white;\n}\n\n/* Детальная информация о занятии */\n.st-lesson-details-info {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.st-info-section-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.st-info-section-content {\n  padding: 14px;\n}\n\n/* ОДИНАКОВАЯ СЕТКА для деталей и статистики - 4 колонки */\n.st-info-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.st-info-grid-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n  min-height: 80px;\n  justify-content: center;\n}\n\n.st-info-grid-label {\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.st-info-grid-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n/* Статистика посещаемости */\n.st-attendance-stats-section {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.st-attendance-stats-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.st-attendance-stats-content {\n  padding: 20px;\n}\n\n/* Процент посещаемости - отдельный блок */\n.st-attendance-percentage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #e6f0ff 100%);\n  border-radius: 8px;\n  border: 1px solid #c7d2fe;\n  margin-top: 16px;\n}\n\n/* Стили для состояния загрузки */\n.st-lesson-info-loading {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n}\n\n.st-lesson-info-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f1f5f9;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: st-spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n.st-lesson-info-loading-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n/* Стили для отсутствующей информации */\n.st-lesson-info-no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px dashed #cbd5e1;\n  margin: 20px 0;\n}\n\n.st-lesson-info-no-data-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  color: #cbd5e1;\n}\n\n.st-lesson-info-no-data h4 {\n  margin: 0 0 12px 0;\n  color: #475569;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.st-lesson-info-no-data p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Стили для состояния загрузки данных */\n.st-loading-message {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n  font-size: 16px;\n  background: white;\n  border-radius: 12px;\n  margin: 20px 0;\n  border: 1px solid #e2e8f0;\n}\n\n.st-no-data-message {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n  font-size: 16px;\n  background: white;\n  border-radius: 12px;\n  margin: 20px 0;\n  border: 1px solid #e2e8f0;\n}\n\n/* Стили для скроллбара */\n.st-attendance-table-wrapper::-webkit-scrollbar {\n  height: 8px;\n}\n\n.st-attendance-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.st-attendance-table-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.st-attendance-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .st-attendance-section {\n    width: 100%;\n    min-width: 100%;\n    padding: 12px;\n  }\n  \n  .st-attendance-filters {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .st-attendance-title-container {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .st-modal-content {\n    min-width: 90vw;\n    margin: 20px;\n  }\n  \n  .st-column-name {\n    width: 200px;\n    min-width: 200px;\n  }\n  \n  .st-column-number {\n    width: 50px;\n    min-width: 50px;\n  }\n  \n  .st-percentage-circle {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .st-percentage-circle::before {\n    width: 64px;\n    height: 64px;\n  }\n  \n  .st-percentage-value {\n    font-size: 16px;\n  }\n  \n  .st-cell-status {\n    height: 32px;\n    width: 32px;\n    font-size: 12px;\n  }\n  \n  .st-subject-selector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .st-subject-select {\n    min-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .st-attendance-cabinet-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .st-header-btn {\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .st-info-tooltip {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    min-width: 280px;\n    max-width: 90vw;\n  }\n  \n  .st-info-icon-btn:hover .st-info-tooltip {\n    opacity: 0;\n    visibility: hidden;\n  }\n  \n  .st-info-icon-btn:focus .st-info-tooltip,\n  .st-info-icon-btn:active .st-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@media (max-width: 480px) {\n  .st-header-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n  \n  .st-lesson-info-modal-header {\n    padding: 16px;\n  }\n  \n  .st-lesson-info-modal-content {\n    padding: 16px;\n  }\n  \n  .st-info-grid-4 {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .st-info-grid-item {\n    padding: 14px 8px;\n    min-height: 65px;\n  }\n  \n  .st-info-grid-value {\n    font-size: 16px;\n  }\n  \n  .st-percentage-circle {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .st-percentage-circle::before {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .st-percentage-value {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
